// stores/usePerformanceCheck.ts
import { defineStore } from "pinia";

export const usePerformanceStore = defineStore("performance", {
  state: () => ({
    isLowEnd: false,
  }),
  actions: {
    detect() {
      const cores = navigator.hardwareConcurrency || 2;
      const memory = (navigator as any).deviceMemory || 2;

      this.isLowEnd = cores <= 2 || memory < 4;
    },
  },
});
